module.exports = __webpack_public_path__ + "images/nodata.748b68f7.png";